export function orderTotals(items) {
  if (!Array.isArray(items) || !items.length)
    throw new Error("Order items are required.");
  let totalCents = 0;
  const variations = items.map((item) => {
    const quantity = Number(item.quantity);
    const priceText = String(item.price);
    if (
      !item.uuid ||
      !Number.isFinite(quantity) ||
      quantity <= 0 ||
      !/^\d+(\.\d+)?$/.test(String(quantity)) ||
      !/^\d+(\.\d{1,2})?$/.test(priceText)
    ) {
      throw new Error("Invalid order item.");
    }
    const priceCents = Math.round(Number(priceText) * 100);
    // Scale the decimal quantity to an integer before multiplication, then
    // round the line amount to cents. Totals add the rounded line amounts.
    const [whole, fractional = ""] = String(quantity).split(".");
    const scaledQuantity = Number(whole + fractional);
    const scale = 10 ** fractional.length;
    const scaledAmount = scaledQuantity * priceCents;
    if (
      !Number.isSafeInteger(scaledQuantity) ||
      !Number.isSafeInteger(scale) ||
      !Number.isSafeInteger(scaledAmount)
    ) {
      throw new Error("Order amount is too large.");
    }
    const amountCents = Math.round(scaledAmount / scale);
    totalCents += amountCents;
    if (!Number.isSafeInteger(totalCents) || !Number.isSafeInteger(amountCents))
      throw new Error("Order amount is too large.");
    return {
      uuid: item.uuid,
      quantity,
      price: priceCents / 100,
      amount: amountCents / 100,
    };
  });
  return { product_variations: variations, total_amount: totalCents / 100 };
}
